module.exports = __webpack_public_path__ + "static/privi-254619ead9a85ddbf27a63565a3f3410.png";